export default "__VITE_ASSET__tSuAZhdh__"